import { QUIZ_COURSES_RECOMMEND } from '@/constant/QueryKeyName';
import { useScreen } from '@/hooks/useScreen';
import { getRecommendationQuizCourses } from 'apis/tms/course.api';
import dynamic from 'next/dynamic';
import { useInView } from 'react-intersection-observer';
import { useQuery } from 'react-query';

const DesktopPostDetailCourseSuggestion = dynamic(
  () =>
    import(
      '@/components/elements/feed/course-suggestion/post-detail-cousre-suggest/DesktopPostDetailCourseSuggestion'
    )
);
const MobilePostDetailCourseSuggestion = dynamic(
  () =>
    import(
      '@/components/elements/feed/course-suggestion/post-detail-cousre-suggest/MobilePostDetailCourseSuggestion'
    )
);

const PostDetailCourseSuggestion = () => {
  const { ref, inView } = useInView();
  const { isDesktop } = useScreen();

  const { data } = useQuery(
    [QUIZ_COURSES_RECOMMEND],
    getRecommendationQuizCourses,
    {
      staleTime: 5 * 60 * 1000,
      cacheTime: 5 * 60 * 1000,
    }
  );

  return (
    <div
      ref={ref}
      className="h-fit flex-shrink-0 bg-Other/White p-2 xl:bg-transparent xl:p-0"
    >
      {inView && !!data ? (
        <div className="flex h-fit flex-col gap-4 rounded-lg border border-Other/Outlinedborder-stroke bg-primary_blue_bg p-2 xl:w-[273px] xl:border-none xl:bg-transparent xl:p-0">
          {isDesktop ? (
            <DesktopPostDetailCourseSuggestion courses={data} />
          ) : (
            <MobilePostDetailCourseSuggestion courses={data} />
          )}
        </div>
      ) : (
        <div className="h-[393px] xl:w-[273px]"></div>
      )}
    </div>
  );
};

export default PostDetailCourseSuggestion;
